"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6 8.83V20h12V4h-7.17zm5 .19L13 9v4h3l-4 4-4-4h3z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 18H6V8.83L10.83 4H18z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "m12 17 4-4h-3V9l-2 .02V13H8z"
}, "2")], 'SimCardDownloadTwoTone');